import React from 'react';
import { PageHero, SectionLabel, PrimaryButton } from '../components/Shared';
import { services, images } from '../data/mock';

const Services = () => {
  return (
    <>
      <PageHero
        eyebrow="השירותים"
        title="כל מה שהעסק צריך כדי לגדול —"
        accent="אצל ספק אסטרטגי אחד."
        subtitle="במקום להיות המתווכים בין הקמפיינר, הבונה והמעצב — אתם מקבלים מערך שיווק מתוקתק, מתוכנן ומנוהל, שמכוון ישירות להגדלת המכירות של העסק."
        image={images.whatWeDo}
      />

      <section className="py-20 lg:py-28 bg-cream" aria-label="רשימת שירותים">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="space-y-px">
            {services.map((s) => (
              <article
                key={s.n}
                className="reveal grid lg:grid-cols-12 gap-8 lg:gap-16 py-12 lg:py-16 border-t border-navy/15"
              >
                <div className="lg:col-span-3">
                  <p className="font-serif text-5xl lg:text-6xl text-bronze" aria-hidden="true">{s.n}</p>
                </div>
                <div className="lg:col-span-9">
                  <h2 className="display-2 text-navy mb-4">{s.title}</h2>
                  <p className="font-serif italic text-navy/70 text-xl mb-6">{s.sub}</p>
                  <p className="lede text-navy/75 text-lg max-w-3xl">{s.body}</p>
                </div>
              </article>
            ))}
          </div>
          <div className="mt-20 reveal">
            <PrimaryButton to="/contact">קבעו שיחת אבחון למערך הצמיחה שלכם</PrimaryButton>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
